import { DashboardOutlined, CalendarOutlined, UserSwitchOutlined, AuditOutlined, ContactsOutlined, PaperClipOutlined, BankOutlined, CarOutlined } from "@ant-design/icons";
import React from "react";

export interface MenuConfigItem {
    id: number;
    label: string;
    icon?: React.ReactNode;
    path: string;
    parentId?: number;
}

export const MENU_CONFIG: MenuConfigItem[] = [
    {
        id: 1, label: "Dashboard", icon: <DashboardOutlined />, path: "/dashboard"
    },
    {
        id: 2, label: "Booking", icon: <CalendarOutlined />, path: "/booking"
    },
    {
        id: 3, label: "Driver Attendance", icon: <UserSwitchOutlined />, path: "/driverattendance"
    },
    {
        id: 4, label: "Driver Report", icon: <AuditOutlined />, path: "/driverreport"
    },
    {
        id: 5,
        label: "Attachment Enquiry",
        icon: <PaperClipOutlined />,
        path: "/aenquiry",
    },
    {
        id: 6,
        label: "Enterprise Enquiry",
        icon: <BankOutlined />,
        path: "/EnterpriseEnquiry",
    },
    {
        id: 7,
        label: "Available Cabs",
        icon: <CarOutlined />,
        path: "/AvailableCabs",
    },

    { id: 11, label: "Add", path: "/booking/add", parentId: 2 },
    { id: 12, label: "New", path: "/booking/new", parentId: 2 },
    { id: 13, label: "Live", path: "/booking/live", parentId: 2 },
    { id: 14, label: "Completed", path: "/booking/completed", parentId: 2 },
    { id: 15, label: "Enquiry", path: "/booking/enquiry", parentId: 2 },
    { id: 16, label: "Cancel", path: "/booking/cancel", parentId: 2 },

    { id: 21, label: "Driver Call", path: "/driverreport/driver-call", parentId: 4 },
    { id: 22, label: "Add Driver", path: "/driverreport/add-driver", parentId: 4 },
    { id: 23, label: "Driver Table", path: "/driverreport/driver-table", parentId: 4 },

    { id: 31, label: "Enquiry", path: "/aenquiry/AEnquiry", parentId: 5 },
    { id: 32, label: "Add Enquiry", path: "/aenquiry/add-enquiry", parentId: 5 },
];